import { OperationalModel } from '@constants/canvas/layers';
import { CiaFilters } from '@context/ProjectFilters/types';
import { DEFAULT_SCOPE_TYPE, ScopeType } from '@utils/domains';
import { BehaviorSubject } from 'rxjs';

type Filters = {
  validationStatus: string[];
  operationalStatuses: string[];
  operatingModelStatuses: OperationalModel[];
  reviewStatus: string[];
  domains: string[];
  scopeType: ScopeType;
  partners: string[];
  cis: string[];
  reportInclusion: string[];
  cia: CiaFilters;
};

export const filtersSubject = new BehaviorSubject<Filters>({
  validationStatus: [],
  operationalStatuses: [],
  operatingModelStatuses: [],
  reviewStatus: [],
  domains: [],
  scopeType: DEFAULT_SCOPE_TYPE,
  partners: [],
  cis: [],
  reportInclusion: [],
  cia: {
    assurance_level: {},
    coverage: {},
    applicability: {},
  },
});
